import { FC, ReactNode } from "react";
import { Content } from "@jobber/components/Content";
import { useBreakpoints } from "@jobber/hooks/useBreakpoints";

type DashboardFrameProps = {
    readonly children: ReactNode | ReactNode[],
};

export const DashboardFrame: FC<DashboardFrameProps> = ({
    children,
}) => {
    let breakpoints = useBreakpoints();

    return (
        <div
            style={{
                width: "100%",
                padding: "40px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                flexGrow: 1,
            }}
        >
            <div
                style={{
                    display: "flex",
                    gap: "40px",
                    flexDirection: breakpoints.mediumAndUp ? "row" : "column",
                    justifyContent: "space-between",
                    flexGrow: 1,
                    width: "100%",
                }}
            >
                <div
                    style={{
                        flexGrow: 1,
                        width: "100%",
                    }}
                >
                    <Content spacing={"larger"}>
                        {/*{heading}*/}
                        <div
                            style={{
                                maxWidth: "100%",
                                minHeight: breakpoints.mediumAndUp ? "317px" : "100%",
                            }}
                        >
                            {children}
                        </div>
                    </Content>
                </div>
            </div>
        </div>
    );
};